import { LeftNavCollapseDisabledProvider } from '@ms/yammer-features-app-navigation';
import type { FC } from 'react';
import React from 'react';

import { AppLeftNavContent } from './AppLeftNavContent';
import LoadableAppLeftNav from './LoadableAppLeftNav';

export const AppLeftNav: FC = () => (
  <AppLeftNavContent
    collapsedOverlayNav={
      <LeftNavCollapseDisabledProvider>
        <LoadableAppLeftNav />
      </LeftNavCollapseDisabledProvider>
    }
  />
);
